<script setup lang="ts">
import { useSegmentationDialog } from '@/src/composables/useSegmentationDialog';

const defaultViewerIDs: string[] = ['ContoursLeft', 'ContoursRight'];
const segDialog = useSegmentationDialog();

function beginSegmentation(viewerIDs: string[] = defaultViewerIDs) {
  segDialog.trigger(viewerIDs.map(id => ({ viewerID: id })));
}

function segmentActiveViewers(viewerIDs: string[] = defaultViewerIDs) {
  beginSegmentation(viewerIDs);
}

function abortSegmentation() {
  segDialog.abort();
}

defineExpose({
  beginSegmentation,
  segmentActiveViewers,
  abortSegmentation,
  isSegmentationActive: segDialog.isSegmentationActive,
  segDialog,
});
</script>
